<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search >
        <search-box class="search-box">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="80px" size="mini">
            <el-form-item label="角色名称" prop="roleName">
              <el-input v-model="searchForm.roleName"></el-input>
            </el-form-item>
            <el-form-item label="角色状态" prop="status">
              <el-select v-model="searchForm.status" placeholder="请选择">
                <el-option label="全部 " value=""></el-option>
                <el-option label="启用 " value="启用"></el-option>
                <el-option label="停用" value="停用"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <el-table stripe v-loading="loading" ref="tableRef" border highlight-current-row :data="tableData" :height="maxTableHeight">
          <el-table-column prop="roleCode" label="角色编码" show-overflow-tooltip></el-table-column>
          <el-table-column prop="roleName" label="角色名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="角色状态" show-overflow-tooltip></el-table-column>
          <el-table-column prop="updatedBy" label="更新人" show-overflow-tooltip></el-table-column>
          <el-table-column prop="updatedDate" label="更新时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template v-slot="{row}">
              <el-link type="primary" :underline="false" @click="edit(row)">编辑</el-link>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <edit-dialog
      ref="editRef"
      :isShowEditDialog.sync="isShowEditDialog" 
      :checkedId="checkedId"
      :roleCode="roleCode"
      @saveSuccess="onSearch"
    />

  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from 'moment';
import editDialog from "./components/edit-dialog.vue";
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {
    editDialog
  },
  data() {
    return {
      isShowImport: false,
      searchForm: {
        roleName: "",
        status: "",
      },
      isEdit: false,
      newAddData: {},
      formData: {
        id: '',
        customerId: "",
        customerName: "",
        regMerType:"",
        shopName: "",
        merNo: "",
        merNoWithdraw: "",
        legalName: "",
        shopLic: "",
        bankNo: "",
        bankName: ""
      },

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      isShowEditDialog: false,
      changePayWayParams: {},
      checkedId: [],
      roleCode: ''
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.configure.roleConfigList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key == 'updateDateStart' || key == 'updateDateEnd') {
          if (val) {
            this.filterParam[key] = moment(val).format('YYYY-MM-DD');
          }
        }else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    edit({roleCode,orgIdList}) {
      const checkedId = orgIdList || []
      this.$refs.editRef.open(checkedId, roleCode)
    },
  },
  mounted() {
    this.init() 
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .date-input  {
    width 220px !important
  }
}
</style>
